//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('finishPohScan', {
//        templateUrl: 'views/components/views/finishPohScan/finishPohScan.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'finishPohScanService', 'trNewJobService', 'layoutService', function (stateService, utilityService, finishPohScanService, trNewJobService, layoutService) {

//            // #region VARIABLES & DEFINITIONS
            
//            const vm = this;
//            let webPageName = stateService.getCurrentName();

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                labourNameButtons: [
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => stateService.go('selectlabourpu', { webpagename: webPageName }) }
//                ],
//                operationNameButtons: [
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => stateService.go('selectoperationpu', { webpagename: webPageName }) }
//                ],
//                equipmentNameButtons: [
//                    {
//                        id: 'search',
//                        icon: 'fas fa-search',
//                        color: 'primary',
//                        type: 'primary',
//                        onClick: () => {
//                            stateService.go('selectequipmentpu', {
//                                webpagename: webPageName,
//                                operation_id: vm.model.setting.operation_id
//                            });
//                        }
//                    }
//                ],
//                barcodeButtons: [
//                    { id: 'search', icon: 'fas fa-search', color: 'success', type: 'success', onClick: () => searchOrScan() }
//                ],
//                filterScan: {
//                    barcode: ''
//                },
//                setting: {},
//                itemsListStockBatchLasts: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region PROCEDURE CALLS
            
//            async function loadSetting() {
//                vm.model.setting = (await finishPohScanService.getSetting())[0];
//            }

//            async function loadStockBatchLasts() {
//                return vm.model.itemsListStockBatchLasts = await finishPohScanService.listStockBatchLasts(vm.model.setting);
//            }

//            async function searchOrScan() {
//                if (utilityService.validateParmsValue(vm.model.filterScan.barcode) !== true) return;

//                try {
//                    const response = (await trNewJobService.scanProductionOrder({ barcode: vm.model.filterScan.barcode }))[0];

//                    if (response) {
//                        if (response?.barcodetype === 'LA') {
//                            loadSetting();
//                        } else if (response?.barcodetype === 'PO' || response?.barcodetype === 'PT') {
//                            stateService.go(response?.webpagename, response?.parms);
//                        }
//                    }
//                } finally {
//                    clear('barcode');
//                }
//            }

//            // #endregion PROCEDURE CALLS

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'barcode':
//                        vm.model.filterScan.barcode = '';
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region SCAN FUNCTION
            
//            vm.searchOrScan = function () {
//                searchOrScan();
//            }

//            // #endregion SCAN FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();

//                // Redirecting to a new webpage if webpagename has value
//                if (vm.model.setting.webpagename > '') stateService.go(vm.model.setting.webpagename, { webpagename: webPageName });
//                if (vm.model.setting.show_last_produced_stockbatches === '1') return loadStockBatchLasts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
